<div class="context-view">
  <div class="driver-schedule-container">
    <dx-scheduler
      maxAppointmentsPerCell="unlimited"
      [dataSource]="appointments"
      [views]="views"
      [currentView]="viewName"
      [useDropDownViewSwitcher]="true"
      [currentDate]="fromDate"
      [height]="schedulerHeight"
      [startDayHour]="0"
      [endDayHour]="24"
      [cellDuration]="360"
      [groups]="groups"
      [resources]="resources"
      [showCurrentTimeIndicator]="true"
      [shadeUntilCurrentTime]="true"
      [crossScrollingEnabled]="true"
      appointmentTemplate="appointmentTemplate"
      appointmentTooltipTemplate="appointmentTooltipTemplate"
      resourceCellTemplate="resourceCellTemplate"
      (onAppointmentFormOpening)="onAppointmentFormOpening($event)"
      (onAppointmentUpdating)="onAppointmentUpdating($event)"
      (onAppointmentDblClick)="onAppointmentDblClick($event)"
      (onAppointmentContextMenu)="onCellContextMenu($event)"
      (onCellContextMenu)="onCellContextMenu($event)"
      (onAppointmentRendered)="onAppointmentRendered($event)"
      [ngClass]="{ 'dx-scheduler-loading': isLoading }"
      dateCellTemplate="dateCellTemplate"
      timeCellTemplate="timeCellTemplate"
      dataCellTemplate="dataCellTemplate"
      (onContentReady)="onContentReady()">
      <dxo-editing [allowDeleting]="false" [allowDragging]="false" [allowResizing]="false"></dxo-editing>

      <div
        *dxTemplate="let cellData of 'dateCellTemplate'"
        [class.weekend]="cellData.date && (cellData.date.getDay() === 0 || cellData.date.getDay() === 6)">
        {{ cellData.date | date: 'EE dd.MM.yyyy' }}
      </div>
      <div
        *dxTemplate="let cellData of 'timeCellTemplate'"
        [class.weekend]="cellData.date && (cellData.date.getDay() === 0 || cellData.date.getDay() === 6)">
        {{ cellData.date | date: 'HH:mm' }}
      </div>
      <div
        *dxTemplate="let cellData of 'dataCellTemplate'"
        [class.weekend]="
          cellData.startDate && (cellData.startDate.getDay() === 0 || cellData.startDate.getDay() === 6)
        "></div>

      <!-- Shared Template -->
      <ng-template #appointmentTemplate let-data>
        @if (data.appointmentData.AppointmentType === AppointmentType.PROJECT) {
          <div>
            <div class="appointment-content">
              @if (data.appointmentData.isPrime) {
                <app-badge-variant
                  class="prime-logistic-badge"
                  badge="none"
                  label="PL"
                  size="24"
                  [shape]="Shape.Shield"
                  backgroundColor="var(--prime-logistics-color-1)"
                  [tooltip]="'ASSIGNMENT.INFOFILTER.PRIME_LOGISTIC' | translate" />
              }
              <i class="dx-icon-car"></i>
              <div class="project-color-indicator" [style.background]="data.appointmentData.driverStateColor"></div>
              <b
                class="project-id"
                tabindex="0"
                (click)="onProjectClick(data.appointmentData.ProjectNo)"
                (keydown.enter)="onProjectClick(data.appointmentData.ProjectNo)">
                [{{ data.appointmentData.ProjectNo }}]
              </b>
              @if (data.appointmentData.Vehicle) {
                <span class="dot">·</span>
              }
              <span>{{ data.appointmentData.Vehicle }}</span>
              @if (data.appointmentData.Text) {
                <span class="dot">·</span>
              }
              <span>{{ data.appointmentData.Text }}</span>
            </div>
          </div>
        }
        @if (data.appointmentData.AppointmentType === AppointmentType.NOTE) {
          <div class="note-appointment" [style.background]="data.appointmentData.appointmentColor">
            <div class="appointment-content">
              <i class="dx-icon {{ data.appointmentData.noteTypeIcon }}"></i>
              <span>{{ data.appointmentData.Text }}</span>
            </div>
          </div>
        }
      </ng-template>

      <!-- Appointment Template -->
      <div *dxTemplate="let appointment of 'appointmentTemplate'">
        <div class="appointment-wrapper" [ngClass]="appointment.appointmentData.appointmentCssClass">
          <ng-container *ngTemplateOutlet="appointmentTemplate; context: { $implicit: appointment }"> </ng-container>
          @if (appointment.appointmentData.isWeekAppointment) {
            <div class="week-appointment" [style.background]="appointment.appointmentData.appointmentColor">
              <div class="appointment-content">
                <div class="arrow-line">
                  <div class="arrow-head"></div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>

      <!-- Tooltip Template -->
      <div *dxTemplate="let appointment of 'appointmentTooltipTemplate'">
        <ng-container *ngTemplateOutlet="appointmentTemplate; context: { $implicit: appointment }"></ng-container>
        @if (appointment.appointmentData.isWeekAppointment) {
          <div>
            <div class="appointment-content">
              <div
                class="project-color-indicator"
                [style.background]="appointment.appointmentData.appointmentColor"></div>
              {{ appointment.appointmentData.Text | translate }}
              <i
                class="dx-icon-trash"
                (click)="onRemoveWeekAppointment(appointment.appointmentData)"
                (keydown.enter)="onRemoveWeekAppointment(appointment.appointmentData)"
                tabindex="0"
                role="button"></i>
            </div>
          </div>
        }
      </div>

      <div *dxTemplate="let resource of 'resourceCellTemplate'">
        <div class="resource-cell">
          <div class="driver-name" [id]="resource.data.id">{{ resource.data.identifier ?? resource.data.text }}</div>
          <div class="week-info">
            @if (resource.data.weekStart) {
              <div>L: {{ resource.data.weekStart | date: 'dd.MM.yyyy' }}</div>
            }
            @if (resource.data.weekStartShort) {
              <div>S: {{ resource.data.weekStartShort | date: 'dd.MM.yyyy' }}</div>
            }
          </div>
        </div>
      </div>
    </dx-scheduler>

    <dx-popup
      [(visible)]="isPopupVisible"
      [dragEnabled]="false"
      [showTitle]="true"
      [title]="(isEditMode ? 'SCHEDULE.EDIT_NOTE' : 'SCHEDULE.ADD_NOTE') | translate"
      [width]="'600px'"
      [height]="'550px'"
      (onHiding)="onPopupHiding()">
      <div *dxTemplate="let data of 'content'">
        <form (submit)="onFormSubmit($event)">
          <div class="dx-fieldset">
            <div class="dx-field">
              <div class="dx-field-label">Text</div>
              <div class="dx-field-value">
                <dx-text-area [(value)]="newAppointmentData.Text" [height]="200" [maxLength]="300" placeholder="...">
                </dx-text-area>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">Von</div>
              <div class="dx-field-value">
                <dx-date-box [(value)]="newAppointmentData.startDate!" type="datetime" [showClearButton]="true">
                </dx-date-box>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">Bis</div>
              <div class="dx-field-value">
                <dx-date-box [(value)]="newAppointmentData.endDate!" type="datetime" [showClearButton]="true">
                </dx-date-box>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">Typ *</div>
              <div class="dx-field-value">
                <dx-select-box
                  [(value)]="newAppointmentData.NoteType!"
                  [items]="noteTypes"
                  [valueExpr]="'value'"
                  [displayExpr]="'display'"
                  [showClearButton]="true"
                  [stylingMode]="'outlined'"
                  [className]="noteTypeValidationStatus === 'invalid' ? 'invalid-select' : ''">
                </dx-select-box>
                @if (noteTypeValidationStatus === 'invalid') {
                  <div class="validation-error">
                    {{ 'SCHEDULE.REQUIRED' | translate }}
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="popup-buttons">
            <dx-button
              [text]="'BUTTONS.SAVE' | translate"
              type="success"
              [useSubmitBehavior]="true"
              [disabled]="busy.busy()">
            </dx-button>
            @if (isEditMode) {
              <dx-button
                [text]="'BUTTONS.DELETE' | translate"
                type="danger"
                [disabled]="busy.busy()"
                (onClick)="onDeleteNote()">
              </dx-button>
            }
            <dx-button
              [text]="'BUTTONS.CANCEL' | translate"
              type="normal"
              [disabled]="busy.busy()"
              (onClick)="onPopupHiding()">
            </dx-button>
          </div>
        </form>
      </div>
    </dx-popup>

    <dx-context-menu
      [items]="contextMenuItems"
      [(visible)]="contextMenuVisible"
      [width]="200"
      target=".dx-scheduler-date-table-container"
      (onItemClick)="onContextMenuItemClick($event)">
    </dx-context-menu>

    <app-loader [hide]="!isLoading && !isRepainting"></app-loader>
  </div>
</div>
